import { render, staticRenderFns } from "./RestrictedCharacterInput.vue?vue&type=template&id=00d828c4&scoped=true&"
import script from "./RestrictedCharacterInput.vue?vue&type=script&lang=js&"
export * from "./RestrictedCharacterInput.vue?vue&type=script&lang=js&"
import style0 from "./RestrictedCharacterInput.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RestrictedCharacterInput.vue?vue&type=style&index=1&id=00d828c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d828c4",
  null
  
)

export default component.exports